











import { defineComponent } from "@vue/composition-api";
import ModalView from "@/components/ModalView";
import DiscoveryFilterTagsController from "./DiscoveryFilterTagsController.vue";

export default defineComponent({
  name: "DiscoverySelectTagsModal",
  components: { DiscoveryFilterTagsController, ModalView },
  props: {
    value: { type: Boolean, required: true },
    selectedTags: { type: Array as () => string[], required: true },
  },
  data() {
    return {
      showClear: false,
    };
  },
  watch: {
    selectedTags: {
      handler(tags: string[]) {
        this.showClear = tags.length > 0;
      },
      immediate: true,
    },
  },
});
